import { useQuery } from '@tanstack/react-query'

import type { TPermissionKey } from '@/core/types/permission'
import { authUserQueryOptions } from '@/modules/auth/auth.hooks'

export function useAuth() {
  const { data: user, isPending, isError } = useQuery(authUserQueryOptions())

  const hasPermission = (permission: TPermissionKey): boolean =>
    user?.permissions.includes(permission) ?? false

  return {
    user: user ?? null,
    isAuthenticated: Boolean(user),
    isLoading: isPending,
    isError,
    hasPermission,
  }
}
